import angular from 'angular';

export const TitleListDirectiveModule = angular.module('acme.common.directive.titleList', []).directive('titleList', [
  function () {
    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/titleList/titleList.tpl.html',
      scope: {
        type: '@',
        listTitle: '@listtitle',
      },

      link: function ($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: [
        '$scope',
        function ($scope) {
          $scope.titleList = {
            listItems: [],

            init: function () {
              this.listItems = this.getTypeData($scope.type);
            },

            getTypeData: function (type) {
              var data;

              switch (type) {
                case 'recentlyCreatedResourceTemplates':
                  data = [
                    {
                      name: 'Tour Guide',
                      href: '#',
                    },
                    {
                      name: 'Table',
                      href: '#',
                    },
                  ];
                  break;
                case 'recentlyScheduledPrograms':
                  data = [
                    {
                      name: 'Van Gogh Tour',
                      href: '#',
                      description: 'Friday, 9th 2014 @ 10:00 AM',
                    },
                    {
                      name: 'Oscar-Claude Monet Tour',
                      href: '#',
                      description: 'Friday, 9th 2014 @ 8:00 AM',
                    },
                  ];
                  break;
                default:
                  this.isShown = false;
                  data = [];
              }

              return data;
            },
          };

          $scope.titleList.init();
        },
      ],
    };
  },
]).name;
